module.exports = __webpack_public_path__ + "img/college4.ece61c3d.png";